// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TradingToolsScreenTemplate from '@front/templates/TradingToolsScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { DataCache } from '@shared/commons/DataCache';
let instance = null;
export class TradingToolsScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TradingToolsScreen';
    }
    oncomplete() {
        super.oncomplete();
        this.getLinks();
        this.on('tradingCentralLinkClick', this.tradingCentralLinkClick);
        this.on('autochartistLinkClick', this.autochartistLinkClick);
        this.center();
        this.localize();
    }
    getLinks() {
        void this.set('tradingCentralTool', DataCache.ExternalLinksCache.getTradingCentralExtLink());
        void this.set('autochartistTool', DataCache.ExternalLinksCache.getAutochartistExtLink());
    }
    static getTradingCentralLink() {
        const tool = DataCache.ExternalLinksCache.getTradingCentralExtLink();
        if (tool == null) {
            return null;
        }
        return tool.getUrl().toString();
    }
    getAutochartistLink() {
        const tool = DataCache.ExternalLinksCache.getAutochartistExtLink();
        if (isNullOrUndefined(tool)) {
            return null;
        }
        return tool.getUrl().toString();
    }
    static getAutochartist_iFrameLink(tool) {
        if (!tool) {
            return null;
        }
        return tool.getUrl().toString();
    }
    localize() {
        void this.set({
            header: Resources.getResource('screen.tradingTools.header')
        });
    }
    autochartistLinkClick() {
        window.open(this.getAutochartistLink());
    }
    tradingCentralLinkClick() {
        window.open(TradingToolsScreen.getTradingCentralLink());
    }
    static show() {
        if (!instance) {
            instance = new TradingToolsScreen();
            instance.on('teardown', function () {
                instance = null;
            });
            MainWindowManager.AddControl(instance);
        }
        instance.setFocus();
    }
}
TerceraWindowBase.extendWith(TradingToolsScreen, {
    partials: { bodyPartial: TradingToolsScreenTemplate },
    data: function () {
        return {
            showHeader: true,
            showFooter: false,
            resizable: false,
            alwaysMiddle: false,
            showBorder: true,
            width: 309,
            height: 207,
            tradingCentralTool: null,
            autochartistTool: null,
            style_addition_body: 'tradingTools-AdditionBody',
            style_addition_header: 'tradingTools-AdditionHeader'
        };
    }
});
